import React from 'react'
import { IIconProps as IProps } from './IIconProps'

// "Generate with AI" sparkle (from the Summ Library, node 3924:137).
const IconAi = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 72 72"
    fill="none"
  >
    <path
      fill={props.color}
      d="M25.6029 47.7541L33.2578 70.2692C34.0423 72.5769 37.2704 72.5769 38.055 70.2692L45.7098 47.7541C45.9675 46.9961 46.561 46.4036 47.3138 46.1525L69.571 38.7286C71.8933 37.954 71.8933 34.6326 69.571 33.858L47.3138 26.4341C46.561 26.183 45.9675 25.5905 45.7098 24.8325L38.055 2.31738C37.2704 0.00966156 34.0423 0.00966879 33.2578 2.31738L25.6029 24.8325C25.3452 25.5905 24.7518 26.183 23.9989 26.4341L1.74175 33.858C-0.580583 34.6326 -0.580583 37.954 1.74175 38.7286L23.9989 46.1525C24.7518 46.4036 25.3452 46.9961 25.6029 47.7541Z"
    />
    <path
      fill={props.color}
      d="M58.3464 14.089L60.6329 20.8143C60.8673 21.5036 61.8315 21.5036 62.0659 20.8143L64.3524 14.089C64.4294 13.8626 64.6066 13.6856 64.8315 13.6106L71.4797 11.3931C72.1734 11.1617 72.1734 10.1696 71.4797 9.9382L64.8315 7.7207C64.6066 7.64569 64.4294 7.46869 64.3524 7.24227L62.0659 0.516988C61.8315 -0.17233 60.8673 -0.172329 60.6329 0.516989L58.3464 7.24227C58.2694 7.46869 58.0922 7.64569 57.8673 7.7207L51.2191 9.9382C50.5254 10.1696 50.5254 11.1617 51.2191 11.3931L57.8673 13.6106C58.0922 13.6856 58.2694 13.8626 58.3464 14.089Z"
    />
  </svg>
)

export default IconAi
